<template>
  <MarketingLayout>
    <header class="page-head">
      <p class="eyebrow">GUIDES</p>
      <h1>Guides to help you <em>grow.</em></h1>
      <p class="lead">Practical, no-fluff guides for running a business people keep coming back to. New guides are added regularly.</p>
    </header>

    <section class="guide-grid">
      <router-link v-for="guide in guides" :key="guide.slug" :to="`/guides/${guide.slug}`" class="guide-card">
        <span class="guide-tag">{{ guide.tag }}</span>
        <h3>{{ guide.title }}</h3>
        <p>{{ guide.description }}</p>
        <span class="guide-meta">{{ guide.readTime }}</span>
      </router-link>
    </section>

    <section class="cta-strip">
      <div>
        <h3>Want a guide on something specific?</h3>
        <p>Tell us what you're trying to figure out and we'll point you in the right direction.</p>
      </div>
      <router-link class="button" to="/contact">Suggest a topic <span>→</span></router-link>
    </section>
  </MarketingLayout>
</template>

<script>
import MarketingLayout from '@/components/MarketingLayout.vue'
import { guides } from '@/data/guides'
import { useSeo } from '@/composables/useSeo'

export default {
  name: 'GuidesPage',
  components: { MarketingLayout },
  setup() {
    useSeo({
      title: 'Guides',
      description: 'Practical, no-fluff guides for setting up and running a WinCard loyalty program, from your first wallet card to managing multiple locations.',
      path: '/guides',
    });
  },
  data() {
    return { guides }
  },
}
</script>

<style scoped>
.page-head { max-width: 620px; margin: 0 auto 60px; text-align: center; }
.page-head .eyebrow { justify-content: center; }
.page-head h1 { font-size: 52px; letter-spacing: -2.6px; line-height: .98; margin: 0 0 18px; font-weight: 600; }
.page-head h1 em { font-family: var(--serif); font-weight: 400; }
.page-head .lead { margin: 0 auto; }

.guide-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; margin-bottom: 90px; }
.guide-card { border: 1px solid #e3e8e4; background: #fff; border-radius: 10px; padding: 24px; display: flex; flex-direction: column; min-height: 190px; }
.guide-tag { font: 500 9px var(--mono); letter-spacing: .8px; color: var(--green); }
.guide-card h3 { font-size: 16px; letter-spacing: -.5px; margin: 12px 0 8px; line-height: 1.25; }
.guide-card p { font-size: 13px; color: var(--muted); line-height: 1.55; margin: 0; flex: 1; }
.guide-meta { font-size: 11px; color: #9aa3a0; margin-top: 14px; }

.cta-strip { background: var(--cream); border: 1px solid #ebefeb; border-radius: 12px; padding: 34px 40px; display: flex; align-items: center; justify-content: space-between; gap: 20px; }
.cta-strip h3 { margin: 0 0 4px; font-size: 19px; }
.cta-strip p { margin: 0; color: var(--muted); font-size: 13px; }
.cta-strip .button { white-space: nowrap; }

@media (max-width: 900px) { .guide-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 650px) { .guide-grid { grid-template-columns: 1fr; } .page-head h1 { font-size: 40px; } .cta-strip { flex-direction: column; align-items: flex-start; } }
</style>
